import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/careerkc.module.scss';
import Card from "react-bootstrap/Card";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import CustomImage from "./CustomImage";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TechTestimonial from './TectAtKcTestimonial';
import Select from 'react-select';
import _debounce from 'lodash/debounce';
import KcNews from './KcNews';
import CustomGalleryCard from './Career/CustomGalleryCard';
import VideoTestimonials from './PST/VideoTestimonials';
import  Ratio  from 'react-bootstrap/Ratio';
import LazyMedia from './LazyMedia';

const Careerkc: React.FC = (props: any) => {
  const ref = useRef<HTMLDivElement>(null);
  const handleButtonClick = () => {
    const target = ref.current;
    if (!target) return;

    const start = performance.now();
    const correctionWindowMs = 1500;

    const align = () => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (performance.now() - start < correctionWindowMs) {
        setTimeout(align, 150);
      }
    };

    align();
  };
  const careerPageData = props?.pageData;
  const [jobLocation, setJobLocation] = useState<string>('All');
  const [jobCategory, setJobCategory] = useState<string>('All Jobs');
  const [selectedJobs, setSelectedJobs] = useState<Object[]>([]);
  const [totalJobs, setTotalJobs] = useState<Object[]>([]);
  const [searchFilter, setSearchFilter] = useState<string>('');
  const [searchKeyword, setSearchKeyword] = useState<string>('');

  const debounceSearchQuery = (searchKeyValue: string) => {
    const search = _debounce(
      () => setSearchFilter(searchKeyValue),
      500
    );
    search();
  };

  const bannerSliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear"
  };

  const gallerySettings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth: true,
    centerMode: true,
    initialSlide:1
  };

  const mobileGallerySettings = {
    dotsClass: [styles.sliderDots, styles.mobileDots].join(' '),
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    centerMode: true,
    centerPadding: "60px",
    variableWidth: true,
  };

  const coreValueMobileSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false,
    className: "center",
    centerMode: true,
  };

  useEffect(() => {
    const jobs: Object[] = [];
    careerPageData.jobOpenings.forEach((jobOpening: any) => {
      jobs.push(...jobOpening.jobs?.map((job: any) => {
        job.category = jobOpening.category
        return job;
      }))
    });
    setTotalJobs(jobs);
  }, []);

  useEffect(() => {
    const searchCondition = !searchFilter;
    const categoryCondition = jobCategory === 'All Jobs' ? true : false;
    const locationCondition = jobLocation === 'All' ? true : false;
    setSelectedJobs(totalJobs.filter((job: any) =>
      (job.category === jobCategory || categoryCondition) &&
      (job.jobLocation?.includes(jobLocation) || locationCondition) &&
      (job.jobTitle.toLowerCase().includes(searchFilter.toLocaleLowerCase()) || searchCondition)
    ));
  }, [searchFilter, jobCategory, jobLocation, totalJobs]);

  const gallerySliderImages = careerPageData.cultureGallerySection?.gallerySliderImages;
  const galleryImages = gallerySliderImages.reduce((acc: any, obj: any, index: number) => {
    if ((index + 1) % 3 === 0) {
      acc.push([obj]);
    } else {
      if ((index + 1) % 3 === 1) {
        acc[acc.length] = [];
      }
      acc[acc.length - 1].push(obj);
    }
    return acc;
  }, []);

  return (
    <>
      <div id='banner' className={styles.bannerSection} style={{ backgroundColor: careerPageData.bannerSection?.sectionBgColor || '#6C48F0' }}>
        {/* desktop slider */}
        <Slider {...bannerSliderSettings} className='d-none d-sm-block'>
          {careerPageData.bannerSection?.desktopBannerImages?.length > 0 &&
            careerPageData.bannerSection?.desktopBannerImages?.map(
              (desktopBanner: any, index: number) => {
                return (
                  <div key={index} className={styles.bannerSlider}>
                    <CustomImage src={desktopBanner.url} object-fit='cover' layout='responsive' object-position='center' alt={desktopBanner.alternativeText} width={1920} height={830} className={`${styles.sliderImage} fill`} />
                  </div>
                )
              }
            )
          }
        </Slider>

        {/* mobile slider */}
        <Slider {...bannerSliderSettings} className={'d-block d-sm-none'}>
          {careerPageData.bannerSection?.mobileBannerImages?.length > 0 &&
            careerPageData.bannerSection?.mobileBannerImages?.map(
              (mobielBanner: any, index: number) => {
                return (
                  <div className={styles.sliderDiv} key={index}>
                    <CustomImage src={mobielBanner.url} object-fit='cover' layout='responsive' object-position='center' alt={mobielBanner?.alternativeText} width={400} height={550} className={`${styles.sliderImage} fill`} />
                  </div>
                )
              }
            )
          }
        </Slider>

        <Container id='edu-expo-box'>
          <div className={styles.bannerContent}>
            <Row className='text-center'>
              <Col lg={12} md={12} xs={12}>
                <Row>
                  <Col>
                    <div className={styles.heading}>
                      <Breadcrumb>
                        <Breadcrumb.Item style={{ opacity: 0.5 }} href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href=""> Careers </Breadcrumb.Item>
                      </Breadcrumb>
                      <div className={styles.content}>
                        <div className={styles.bannerHeading}>
                          <h1 style={{ color: careerPageData.bannerSection?.titleOneColor }}>{careerPageData.bannerSection?.titleOne} 
                            <br />
                            <span style={{ color: careerPageData.bannerSection?.titleTwoColor }}>{careerPageData.bannerSection?.titleTow}</span>
                          </h1>
                          <p>{careerPageData.bannerSection?.subTitle}</p>
                          <Button className={styles.jobOpening} onClick={handleButtonClick}>View Job Openings</Button>
                        </div>
                        <div className={`d-none d-sm-block ${styles.fadeContent}`}>
                          <h2 className={styles.bgHeading}>{careerPageData.bannerSection?.titleOne} <br />
                          <span>
                           {careerPageData.bannerSection?.titleTow}
                          </span>
                           </h2>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      {/* who we are */}
      <div id='whoWeAre' className={styles.whoWeAre} style={{ backgroundColor: careerPageData.whoWeAre?.sectionBgColor || '#6C48F0' }}>
        <div className={styles.customContainer}>
          <Container>
            <Row className='justify-content-center text-center'>
              <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                <div className={styles.whoWeAreContent}>
                  <h2>{careerPageData.whoWeAre?.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: careerPageData.whoWeAre?.description }}></div>
                </div>
              </Col>
            </Row>
            <Row className='justify-content-center text-center'>
              <Col xs={12} lg={12} className="text-center position-relative"> 
                <div className={styles.videoPanel}>
                    <div className={styles.videoBase}></div>
                    <div className={styles.videoPlaceholder}>
                        <Ratio aspectRatio='16x9'>
                          <LazyMedia tag='embed' type='image/svg+xml' src={careerPageData?.videoLink} />
                        </Ratio>
                    </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* How we started... */}
      <div className={styles.howWeStarted} style={{ backgroundColor: careerPageData.howWeStarted?.sectionBgColor || '#6C48F0' }}>
        <div className={styles.customContainer}>
          <Container>
            {
              careerPageData.howWeStarted?.details?.length &&
              careerPageData.howWeStarted?.details?.map((data: any, index: number) => {
                return (
                  <div className={styles.details} key={index}>
                    <Row className={`${index % 2 !== 0 ? styles.rowRev : ''}`}>
                      <Col xl={6} lg={6} md={12} sm={12} xs={12} className='text-center'>
                        <div className={`${styles.imageBox} ${index % 2 === 0 ? styles.leftBox : styles.rightBox}`}>
                          <div className={styles.desktopImage}>
                            <CustomImage src={data.image?.url} alt={data.image?.alternativeText} layout='responsive' width={500} height={600} />
                          </div>
                          <div className={styles.mobileImage}>
                            <CustomImage src={data.mobileImage?.url} alt={data.mobileImage?.alternativeText} layout='responsive' width={330} height={335} />
                          </div>
                        </div>
                      </Col>
                      <Col xl={6} lg={6} md={12} sm={12} xs={12}>
                        <div className={`${styles.content} ${index % 2 === 0 ? styles.firstContent : ''}`}>
                          <h2>{data.title}</h2>
                          <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              })
            }
          </Container>
        </div>
      </div>


      {/* Our core values... */}
      <div className={styles.coreValues}>
        <div className={styles.customContainer}>
          <Container>
            <Row className='justify-content-center text-center'>
              <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                <div className={styles.hedaingDiv}>
                  <h2>{careerPageData.coreValues?.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: careerPageData.coreValues?.description }}></div>
                </div>
              </Col>
            </Row>
          </Container>
          {/* desktop */}
          <div className='d-none d-sm-block'>
            <Container>
              <Row className='justify-content-center'>
                {careerPageData.coreValues?.valueDetails?.length > 0 &&
                  careerPageData.coreValues?.valueDetails.map((valuesData: any, index: number) => {
                    return (
                        <Col xl={3} lg={3} md={6} sm={12} xs={12} key={index}>
                          <Card className={styles.card}>
                            <div className={styles.cirlce} style={{ backgroundColor: valuesData.bgColor }}> {valuesData.label} </div>
                            <div className={styles.text}>
                              <p>{valuesData.value}</p>
                            </div>
                          </Card>
                        </Col>
                    )
                  })
                }
              </Row>
            </Container>
          </div>

          {/* mobile */}
          <div className='d-block d-sm-none'>
            <Container fluid>
              <Row>
                <Slider {...coreValueMobileSliderSettings} className={styles.coreValueMobileSlider}>
                  {careerPageData.coreValues?.valueDetails?.length > 0 &&
                    careerPageData.coreValues?.valueDetails.map((valuesData: any, index: number) => {
                      return (
                        <div key={index}>
                            <Card className={styles.card} >
                            <div className={styles.cirlce} style={{ backgroundColor: valuesData.bgColor }}> {valuesData.label} </div>
                            <div className={styles.text}>
                              <p>{valuesData.value}</p>
                            </div>
                          </Card>
                        </div>
                        
                      )
                    })
                  }
                </Slider>
              </Row>
            </Container>
          </div>
        </div>
      </div>

      {/* Explore opportunities in our */}
      <div className={styles.opportunities}>
        <div className={styles.customContainer}>
          <Container>
            <div className={styles.flexDiv}>
              <div className={styles.explore}>
                <p>{careerPageData.opportunities?.subtitle}</p>
                <h2>{careerPageData.opportunities?.title}</h2>
                <a href={careerPageData.opportunities?.applyNowLink} className={styles.applyNow}>Visit coursefinder.ai</a>
              </div>
              <div className={styles.exploreImage}>
                <CustomImage src={careerPageData.opportunities?.image?.url} alt={careerPageData.opportunities?.image?.alternativeText} objectFit="cover" width={622} height={413} />
              </div>
            </div>
          </Container>
        </div>
      </div>

      {/*  Perks & Benefits*/}
      <div className={styles.perksBenefits}>
         <div className={styles.customContainer}>
          <Container>
            <Row className='text-left'>
              <Col>
                <div className={styles.heading}>
                  <h2>{careerPageData.perkBenefits?.title}</h2>
                </div>
              </Col>
            </Row>
            <Row>
              {careerPageData.perkBenefits?.benefitDetails.length > 0 &&
                careerPageData.perkBenefits?.benefitDetails.map((details: any, index: number) => {
                  return (
                    <Col xs={6} xl={4} lg={4} md={4} sm={6} key={index}>
                      <div className={styles.benefitsDetails}>
                        <div className={styles.image}><CustomImage src={details.iconImage?.url} alt={details.iconImage?.alternativeText} width={100} height={100} /></div>
                        <h3>{details.title}</h3>
                        <div dangerouslySetInnerHTML={{ __html: details.description }}></div>
                      </div>
                    </Col>
                  )
                })
              }

            </Row>
          </Container>
         </div>
      </div>

      <div className={styles.joinUs} style={{ backgroundColor: careerPageData.cultureGallerySection?.sectionBgColor }}>
        <div className={styles.customContainer}>
          <Container>
            <Row>
              <div className={styles.heading}>
                <h2>{careerPageData.cultureGallerySection?.title}</h2>
              </div>
            </Row>
          </Container>
        </div>
      </div>

      {/* desktop view */}
      <div className={`${styles.joinUsSlider} d-none d-sm-block`} >
         <Slider {...gallerySettings} className={styles.gallerySlider}>
          {galleryImages.length > 0 &&
            galleryImages.map((set: any, index: number) => {
              return (
                <div key={index} className={index % 2 === 0 ? styles.column1 : styles.column2}>
                  {set.length > 0 &&
                    set.map((item: any, itemIndex: number) => {
                      return (
                        <div key={itemIndex}>
                          {item.image
                            ? <div className={`${styles.img} ${(index + 1) % 4 === 0 ? styles.largeSliderImage : ''}`}><CustomImage src={item.image?.url} alt={item.image?.alternativeText || ''} width={index + 1 % 4 === 0 ? 620 : 300}
                              height={index % 2 === 0 ? 200 : 420} objectFit='fill' /></div>
                            : <div className={styles.card}><CustomGalleryCard bgColor={item.cardBgColor}
                              title={item.title}
                              titleColor={item.titleColor}
                              subTitle={item.subTitle} /> </div>}
                        </div>
                      )
                    })
                  }
                </div>
              )
            })
          }
        </Slider>
      </div>

      {/* mobile view */}
      <div className={`${styles.joinUsSlider} d-block d-sm-none`}>
        <Slider {...mobileGallerySettings} className={styles.gallerySlider}>
          {galleryImages.length > 0 &&
            galleryImages.map((set: any, index: number) => {
              return (
                <div key={index} className={index % 2 === 0 ? styles.mobileColumn1 : styles.mobileColumn2}>
                  {set.length > 0 &&
                    set.map((item: any, itemIndex: number) => {
                      return (
                        <div key={itemIndex}>
                          {item.image
                            ? <div className={`${styles.img} ${(index + 1) % 4 === 0 ? styles.largeSliderImage : ''}`}><CustomImage src={item.image?.url} alt={item.image?.alternativeText || ''} width={index + 1 % 4 === 0 ? 442 : 214}
                              height={index % 2 === 0 ? 142 : 300} objectFit='cover' /></div>
                            : <div className={styles.card}><CustomGalleryCard bgColor={item.cardBgColor}
                              title={item.title}
                              titleColor={item.titleColor}
                              subTitle={item.subTitle} /> </div>}
                        </div>
                      )
                    })
                  }
                </div>
              )
            })
          }
        </Slider>
      </div>

      <div className={styles.videoTestimonial}>
          {props.pageData.videoTestimonial &&  <VideoTestimonials {...props.pageData.videoTestimonial}/> }
      </div>

      {/* Current Job Openings */}
      <div
        ref={ref}
        className={styles.jobOpenings}
     >
        <div className={styles.customContainer}>
            <Container>
              <Row className='justify-content-center'>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Container className={styles.paddingClass}>
                    <Row className={styles.locationCategory}>
                      <Col xl={6} md={6} lg={6} xs={12} sm={12}>
                        <h2>Current Job Openings</h2>
                      </Col>
                      <Col xl={6} md={6} lg={6} xs={12} sm={12}>
                        <Row className='justify-content-end'>
                          <Col xl={6} md={12} lg={6} xs={12} sm={12} className={styles.softCatgory}>
                            <span className={`${styles.searchLabel} ${styles.locationLable}`}>Location:</span>
                            <Select
                              placeholder={jobLocation || 'Select Location'}
                              value={jobLocation}
                              className={styles.customSelect}
                              classNamePrefix='careersPageSelect'
                              options={[
                                { value: 'All', label: 'All' },
                                ...careerPageData.locations?.map((location: any) => ({
                                  label: location.location,
                                  value: location.location,
                                })),
                              ]}
                              onChange={(selectedLocationOption: any) => setJobLocation(selectedLocationOption.value)}
                            />
                          </Col>
                          <Col xl={6} md={12} lg={6} xs={12} sm={12} className={styles.searchAlign}>
                            <form className='navbar-form' role='search'>
                              <div className='input-group add-on'>
                                <div className={styles.inputBox}>
                                  <input
                                    className='form-control'
                                    placeholder='Search Job'
                                    name='srch-term'
                                    id='srch-term'
                                    type='text'
                                    onChange={(e) => {
                                      setSearchKeyword(e.target.value);
                                      debounceSearchQuery(searchKeyword);
                                    }}
                                    value={searchKeyword}
                                  />
                                  <div className={styles.inputBtn}>
                                    <CustomImage
                                      src="/careersearchicon.svg"
                                      alt="searchco"
                                      width={14}
                                      height={14}
                                      onClick={() => debounceSearchQuery(searchKeyword)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </form>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col className={`${styles.searchLabel} ${styles.allJobs}`}>
                        <div>
                          <span  onClick={(event: any) => { setJobCategory(event.target.innerText) }} className={jobCategory === 'All Jobs' ? styles.active : ''}>All Jobs</span>
                        </div>
                        {careerPageData.jobOpenings?.map((openings: any, index: any) => (
                          <div key={index}>
                            <span  onClick={(event: any) => { setJobCategory(event.target.innerText) }}  className={jobCategory === openings.category ? styles.active : ''}>{openings.category}</span>
                          </div>
                        ))}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                          <div className={styles.border}></div>
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <Container>
                    <Row className="justify-content-center">
                      <Col xl={12} lg={12} xs={12} md={12} sm={12} className="p-0">
                        <Row key={searchFilter}>
                          {selectedJobs?.length > 0 &&
                            selectedJobs.map((job: any, index: number) => (
                              <Col xl={4} lg={4} md={6} xs={12} sm={12} className={styles.cardsMain} key={index}>
                                <a href={job.jobLink}>
                                  <div className={styles.cardCareer}>
                                    <h3>{job.jobTitle}</h3>
                                    <div className={styles.jobLocation}>
                                      {job.jobLocation}
                                    </div>
                                  </div>
                                </a>
                              </Col>
                            )
                            )}
                        </Row>
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
        </div>
      </div>

       {/* Testimonials */}
       <div>
        <TechTestimonial title="What Our Team Feels" bgColor="#DBE8FF" slug={`testimonials?type=employee&_sort=priority:ASC`} />
      </div>

     
      <div className={styles.kctechnews}>
        <KcNews {...props} />
      </div>
    </>
  )
}

export default Careerkc;